import ModuleManager from "../framework/core/module_manager";
import AppData from '../pacakge/public/const/app_data';
import LoaclStorage from "../manager/local_storage";
import GameUtil from "../utility/game_util";
import SdkHandler from "../sdk/SdkHandler";
import LanguageManager from '../manager/language_manager';
import EventManager from "../manager/event_manager";
import LoginModule from "../pacakge/hall/module/login/login_module";
import Debug from '../manager/debug';
import { GameManager } from '../manager/game_manager';
import AppController from "../sdk/app_controller";
import Utility from "../utility/utility";
import LogManager from "../manager/log_manager";
import IAPController from "../sdk/iap_controller";

const { ccclass, property } = cc._decorator;



@ccclass
export default class Init extends cc.Component {
    @property()
    testView: boolean = false;

    @property()
    startCheckGame = false;

    @property()
    closeTestMode = false;

    @property(cc.Canvas)
    canvas: cc.Canvas = null;

    initWithThai = true;

    curDR: cc.Size

    onLoad() {
        Debug.init()
        if (this.initWithThai) {
            AppData.language = "th"
            AppData.apiLanguage = "th-TH"
        }
        GameUtil.init()
        AppData.init()
        this.resize()
        cc.view.setResizeCallback(() => {
            EventManager.instance.dispatch('_resize_');
            this.resize()
        })

        if (CC_PREVIEW) {
            if (this.testView) {
                return
            }
            if (this.closeTestMode) {
                AppData.testMode = false
            }
        }
        LanguageManager.init(AppData.language)

        if (cc.sys.isNative) {
            this.gameStartInit()
        } else {
            if (CC_PREVIEW) {
                this.gameStartInit()
            }
        }
        GameManager.setProfilerNode(AppData.testMode)
        new SdkHandler();
        setTimeout(() => {
            LogManager.instance.init()
        }, 1)
    }

    start() {
        Utility.reportConversionEvent("init_gameLaunch", 1)
        //在web端使用，必须放在start事件中，在加载完登录界面再隐藏闪屏
        if (!cc.sys.isNative && !CC_PREVIEW) {
            this.gameStartInit()
        }
        AppController.instance.ccStart()
        GameManager.initLog()
    }



    gameStartInit() {
        GameManager.gameStartInit()
        if (CC_PREVIEW && this.startCheckGame) {
            AppData.startCheckGame = true
            AppData.testMode = true
        }

        if (CC_JSB && AppData.windowAppData && AppData.windowAppData.startSpecificGame) {
            if (cc.sys.os == cc.sys.OS_IOS) {
                AppData.startCheckGame = LoaclStorage.getString("__SkipCheckGame") != AppData.appVersion
            }
        }
        ModuleManager.instance.init()
        if (Utility.version_judge(AppData.appVersion, "1.3.1")) {  //只有大于v1.3.1才支持JS初始化商品
            IAPController.initIapProduct()
        }
    }

    resize() {
        let canvas = this.canvas
        //保存原始设计分辨率，供屏幕大小变化时使用
        if (!this.curDR) {
            this.curDR = canvas.designResolution;
        }
        var dr = this.curDR;
        var frameSize = cc.view.getFrameSize();
        var rw = frameSize.width;
        var rh = frameSize.height;
        var finalW = rw;
        var finalH = rh;
        cc.log("原始设计分辨率", dr.width, dr.height)
        if ((rw / rh) > (dr.width / dr.height)) {
            //!#zh: 是否优先将设计分辨率高度撑满视图高度。 */
            //cvs.fitHeight = true;
            //如果更长，则用定高
            finalH = dr.height;
            finalW = finalH * rw / rh;
        }
        else {
            /*!#zh: 是否优先将设计分辨率宽度撑满视图宽度。 */
            //cvs.fitWidth = true;
            //如果更短，则用定宽
            finalW = dr.width;
            // finalW = dr.height;
            finalH = rh / rw * finalW;
        }
        canvas.designResolution = cc.size(finalW, finalH);
        canvas.node.width = finalW;
        canvas.node.height = finalH;
        canvas.node.emit('resize');

        AppData.isWidescreen = frameSize.width / frameSize.height >= 2
        AppData.designResolution = canvas.designResolution
        AppData.widescreenOffset = AppData.designResolution.width * (44 / 812)//偏移齐刘海宽度
        // cc.log("canvas", canvas.designResolution, AppData.widescreenOffset)
        cc.systemEvent.emit("canvas_resize")
        if (!cc.sys.isNative && window.orientation != null && window.orientation != undefined) {
            Utility.reportEffect(`sys_orientation_${window.orientation}`)
        }
    }


}
